(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fika-bundle-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fika-bundle-shop')) {
    customElements.define('fika-bundle-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.config = JSON.parse(this.querySelector('[data-shop-config]').textContent);
        this.ids = new Set(this.config.ids.map(Number));
        this.target = 3;
        this.abort = new AbortController();
        this.money = value => new Intl.NumberFormat(this.config.locale,{style:'currency',currency:this.config.currency}).format(value / 100);
        this.addEventListener('click',event => {
          const tier = event.target.closest('[data-tier]');
          if (!tier || this.busy) return;
          this.target = Number(tier.dataset.tier);
          this.renderPrices();
          if (this.cart) this.renderCart(this.cart);
        },{signal:this.abort.signal});
        this.addEventListener('submit',event => {
          const form = event.target.closest('.fika-shop__form');
          if (!form) return;
          event.preventDefault();
          this.mutate('cart/add.js',{items:[{id:Number(form.querySelector('[name=id]').value),quantity:1}]});
        },{signal:this.abort.signal});
        document.addEventListener('cart:update',()=>this.refresh(),{signal:this.abort.signal});
        this.renderPrices();
        this.refresh();
      }
      disconnectedCallback() { this.abort?.abort(); this.ready=false; }
      async request(path,options={}) {
        const response=await fetch((window.Shopify?.routes?.root || '/')+path,{...options,headers:{'Content-Type':'application/json',...options.headers}});
        const data=await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.config.text.error);
        return data;
      }
      renderPrices() {
        const offer=this.dataset.offer==='true';
        this.querySelectorAll('[data-tier]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.tier)===this.target)));
        const price=offer ? [0,4800,3950,3300][this.target] : 4800;
        const condition=offer ? [null,this.config.text.regular,this.config.text.pair,this.config.text.trio][this.target] : this.config.text.regular;
        this.querySelectorAll('.fika-shop__card').forEach(card=>{card.querySelector('[data-card-price]').textContent=this.money(offer ? price : Number(card.dataset.price));card.querySelector('[data-card-original]').hidden=!offer || this.target===1;card.querySelector('[data-card-condition]').textContent=condition;});
        const note=this.querySelector('[data-price-note]');
        if (note) note.textContent=[null,this.config.text.oneNote,this.config.text.pairNote,this.config.text.trioNote][this.target];
      }
      async refresh() {
        const revision=this.refreshRevision=(this.refreshRevision || 0)+1;
        try { const cart=await this.request('cart.js'); if (revision===this.refreshRevision && this.isConnected) this.renderCart(cart); }
        catch(error) { this.querySelector('[data-error]').textContent=error.message; }
      }
      renderCart(cart) {
        this.cart=cart;
        const offer=this.dataset.offer==='true';
        const items=cart.items.filter(item=>this.ids.has(Number(item.variant_id)) && (!offer || item.original_price===4800));
        const count=items.reduce((n,item)=>n+item.quantity,0);
        const text=this.config.text;
        const summary=this.querySelector('.fika-shop__summary');summary.hidden=false;
        this.querySelector('[data-progress]').textContent=text.progress.replace('[count]',String(count)).replace('[target]',String(this.target));
        const topProgress=this.querySelector('[data-top-progress]');
        if(topProgress)topProgress.textContent=this.querySelector('[data-progress]').textContent;
        this.querySelector('[data-next]').textContent=!offer ? '' : count===0 ? text.start : count===1 ? text.oneMore : count===2 ? text.third : count===3 ? text.complete : text.extras;
        const bar=this.querySelector('[role=progressbar]');bar.setAttribute('aria-valuemax',String(this.target));bar.setAttribute('aria-valuenow',String(Math.min(count,this.target)));bar.firstElementChild.style.width=Math.min(count/this.target*100,100)+'%';
        this.querySelectorAll('.fika-shop__card').forEach(card=>{const quantity=items.filter(item=>String(item.variant_id)===card.dataset.variant).reduce((n,item)=>n+item.quantity,0);const badge=card.querySelector('[data-card-count]');badge.hidden=!quantity;badge.textContent=text.selected.replace('[count]',String(quantity));});
        const selected=this.querySelector('.fika-shop__selected');selected.replaceChildren();
        for(const item of items) { const row=document.createElement('div');const label=document.createElement('span');label.textContent=item.product_title+' · '+item.variant_title+' × '+item.quantity;if(item.image){const image=document.createElement('img');image.src=item.image;image.alt='';row.append(image);}const remove=document.createElement('button');remove.type='button';remove.textContent=text.remove;remove.disabled=Boolean(this.busy);remove.addEventListener('click',()=>this.mutate('cart/change.js',{id:item.key,quantity:Math.max(0,item.quantity-1)}));row.append(label,remove);selected.append(row); }
        const total=items.reduce((n,item)=>n+item.final_line_price,0);
        this.querySelector('[data-subtotal]').textContent=count ? text.subtotal.replace('[total]',this.money(total)) : '';
      }
      async mutate(path,body) {
        if(this.busy) return;
        this.busy=true;this.querySelector('[data-error]').textContent='';this.querySelectorAll('button').forEach(button=>button.disabled=true);
        try { const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(element=>element.dataset.sectionId).filter(Boolean))];if(sections.length)body.sections=sections.slice(0,5);const response=await this.request(path,{method:'POST',body:JSON.stringify(body)});const cart=await this.request('cart.js');const drawer=document.querySelector('cart-drawer-component');const autoOpen=drawer?.hasAttribute('auto-open');if(autoOpen)drawer.removeAttribute('auto-open');document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:cart,sourceId:'fika-bundle-shop',data:{source:'fika-bundle-shop',sections:response.sections,itemCount:cart.item_count}}}));if(autoOpen)drawer.setAttribute('auto-open','');this.renderCart(cart); }
        catch(error) { this.querySelector('[data-error]').textContent=error.message;await this.refresh(); }
        finally { this.busy=false;this.querySelectorAll('button').forEach(button=>button.disabled=false); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
